export enum GaugeValueMode {
    FIXED = 'fixed',
    FIELD = 'field',
}
